import {Component, OnInit, OnDestroy, ViewChild, HostListener, AfterViewInit, ViewEncapsulation} from '@angular/core';
import {Router, NavigationEnd} from '@angular/router';
import {NavItem, NavItemType} from '../../md/md.module';
import {Subscription} from 'rxjs/Subscription';
import {LocationStrategy, PlatformLocation, Location} from '@angular/common';
import 'rxjs/add/operator/filter';
import {NavbarComponent} from '../../shared/navbar/navbar.component';
import PerfectScrollbar from 'perfect-scrollbar';
import {AdminLayoutService} from "./admin-layout.service";
import has = Reflect.has;

declare const $: any;

@Component({
    selector: 'app-layout',
    templateUrl: './admin-layout.component.html',
    styleUrls: ['./admin-layout.component.scss'],
    encapsulation: ViewEncapsulation.None,
})

export class AdminLayoutComponent implements OnInit, AfterViewInit {
    public navItems: NavItem[];
    private _router: Subscription;
    url: string;
    location: Location;

    @ViewChild('sidebar') sidebar: any;
    @ViewChild(NavbarComponent) navbar: NavbarComponent;

    constructor(private router: Router, location: Location, public adminLayoutService: AdminLayoutService) {
        this.location = location;
    }

    ngOnInit() {
        this.adminLayoutService.getIcon();
        this.adminLayoutService.getName();
        if (has(sessionStorage, 'theme')){
            this.adminLayoutService.setTheme(sessionStorage.getItem('theme'))
        }else{
            this.adminLayoutService.setTheme('alt-dark-theme');
        }

        const elemMainPanel = <HTMLElement>document.querySelector('.main-panel');
        const elemSidebar = <HTMLElement>document.querySelector('.sidebar .sidebar-wrapper');

        if (window.matchMedia(`(min-width: 960px)`).matches && !this.isMac()) {
            let ps = new PerfectScrollbar(elemMainPanel, {wheelSpeed: 2, suppressScrollX: true});
            ps = new PerfectScrollbar(elemSidebar, {wheelSpeed: 2, suppressScrollX: true});
        }

        this._router = this.router.events.filter(event => event instanceof NavigationEnd).subscribe((event: NavigationEnd) => {
            this.navbar.sidebarClose();
        });

        this.navItems = [
            {type: NavItemType.NavbarLeft, title: 'Dashboard', iconClass: 'fa fa-dashboard'},

            {
                type: NavItemType.NavbarRight,
                title: '',
                iconClass: 'fa fa-bell-o',
                numNotifications: 5,
                dropdownItems: [
                    {title: 'Notification 1'},
                    {title: 'Notification 2'},
                    {title: 'Notification 3'},
                    {title: 'Notification 4'},
                    {title: 'Another Notification'}
                ]
            },
            {
                type: NavItemType.NavbarRight,
                title: '',
                iconClass: 'fa fa-list',

                dropdownItems: [
                    {iconClass: 'pe-7s-mail', title: 'Messages'},
                    {iconClass: 'pe-7s-help1', title: 'Help Center'},
                    {iconClass: 'pe-7s-tools', title: 'Settings'},
                    'separator',
                    {iconClass: 'pe-7s-lock', title: 'Lock Screen'},
                    {iconClass: 'pe-7s-close-circle', title: 'Log Out'}
                ]
            },
            {type: NavItemType.NavbarLeft, title: 'Search', iconClass: 'fa fa-search'},

            {type: NavItemType.NavbarLeft, title: 'Account'},
            {
                type: NavItemType.NavbarLeft,
                title: 'Dropdown',
                dropdownItems: [
                    {title: 'Action'},
                    {title: 'Another action'},
                    {title: 'Something'},
                    {title: 'Another action'},
                    {title: 'Something'},
                    'separator',
                    {title: 'Separated link'},
                ]
            },
            {type: NavItemType.NavbarLeft, title: 'Log out'}
        ];
    }

    ngAfterViewInit() {
        this.runOnRouteChange();
    }

    public isMap() {
        if (this.location.prepareExternalUrl(this.location.path()) === '/maps/fullscreen') {
            return true;
        } else {
            return false;
        }
    }

    runOnRouteChange(): void {
        if (window.matchMedia(`(min-width: 960px)`).matches && !this.isMac()) {
            const elemMainPanel = <HTMLElement>document.querySelector('.main-panel');
            const ps = new PerfectScrollbar(elemMainPanel);
            ps.update();
        }
    }


    isMac(): boolean {
        let bool = false;
        if (navigator.platform.toUpperCase().indexOf('MAC') >= 0 || navigator.platform.toUpperCase().indexOf('IPAD') >= 0) {
            bool = true;
        }
        return bool;
    }
}



// WEBPACK FOOTER //
// ./src/app/layouts/admin/admin-layout.component.ts